import React, { useEffect } from 'react';
import Typo from '../typo';
import NavBar from '../navBar';
import { BackButton } from '../backButton';
import HeaderBackCta from '../headerBackCta';
import HeroBanner from '../heroBanner';
import config from 'utils/config';
import { useSelector } from 'react-redux';
import { getCookie, isWebView } from 'utils/commonFunctions';

const Header = () => {
  const gamedaysData = useSelector((state) => state.createTeam.gamedaysData);
  const gameCookie = getCookie(config.gameCookieName);

  return (
    <>
      <div className='si-header'>
        <div className='si-header__body'>
          <div className='si-gameLvlMenu'>
            <div className='si-main__container'>
              {isWebView() ? null : (
                <div className='si-gameLvlMenu-title'>
                  {
                    <Typo component={'span'} transKey={'menu_lms'}>
                      Top Picks
                    </Typo>
                  }
                </div>
              )}
              {config.isMobile() ? <HeroBanner /> : null}
              <div className='si-menu'>
                <NavBar
                  hasTeam={gamedaysData?.team_gameday_ids?.length}
                  isLoggedIn={!!gameCookie?.guid}
                />
              </div>
            </div>
          </div>
          {/* <div className='si-main__container'>
            <HeaderBackCta />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Header;
